<script setup>
import { ref } from 'vue'
import { downloadFileAsync } from '@/lib/utils'
import { getI18n } from '@/plugins/i18n'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  hideDelete: {
    type: Boolean,
    default: false,
  },
  hideDownload: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['download', 'remove'])

const i18n = getI18n()

const onDownloadFile = (item) => { downloadFileAsync(item.name, item.url) }

const showDeleteDialog = ref(false)

const onRemoveFile = () => { showDeleteDialog.value = true }
</script>

<template>
  <q-item
    v-if="!dense"
    clickable
  >
    <q-item-section
      side
    >
      <q-icon name="mdi-attachment" />
    </q-item-section>
    <q-item-section :class="{ 'mobile-file-name': !dense }">
      {{ item.name }}
    </q-item-section>
    <q-item-section
      side
    >
      <div>
        <q-btn
          v-if="!hideDownload && item.id"
          round
          flat
          icon="mdi-download"
          @click="onDownloadFile(item)"
        />
        <q-btn
          v-if="!hideDelete"
          round
          flat
          icon="mdi-delete"
          @click="onRemoveFile"
        />
      </div>
    </q-item-section>
  </q-item>
  <a
    v-else
    :href="item.url"
    target="_blank"
    rel="noopener noreferrer"
    class="link"
    @click.prevent="onDownloadFile(item)"
  >
    <q-icon name="mdi-attachment" size="xs" class="q-mr-xs" />{{ item.name }}
  </a>
  <confirm-dialog
    v-model="showDeleteDialog"
    :message="i18n.t('common.confirmDeleteMessage', { item: item.name })"
    icon="mdi-delete-outline"
    icon-color="negative"
    @confirm="emit('remove', item)"
  />
</template>

<style scoped lang="scss">
.link {
  display: block;
  color: $primary;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  word-break: break-all;

  &:not(:last-child) {
    margin-bottom: .25rem;
  }

  &:hover {
    text-decoration: underline;
  }
}

.mobile-file-name {
  font-size: 0.85rem;
  padding: 0 6px;
  word-break: break-word;
}
</style>